import { render } from "./core/createElement"
import Home from "./home";
import Login from "./login";
import { auth_service_callback } from "./service/api";
import { dark_theme, dark_theme_stored } from "./utils";

document.addEventListener('DOMContentLoaded', () => {

    dark_theme(dark_theme_stored());

    auth_service_callback(({ is_logged }) => {
        if (is_logged) render(Home);
        else render(Login);
    });

    render(Home);
});